import React from "react";
import { Button, Flex, HStack, Select, Text } from "@chakra-ui/react";
import { ChevronLeftIcon, ChevronRightIcon } from "@chakra-ui/icons";
import { common } from "../constants/constants";

// Shared "Previous / Page N of M (select) / Next" footer control — used at
// the bottom of both ListView and GridView so pagination sits in the same
// place regardless of view mode. Previously ListView rendered this itself
// in its own footer while GridView had no footer at all and relied on the
// page header (DataToolbar) showing pagination instead when in grid mode.
export const PaginationFooter = ({ currentPage, totalPages, handlePageChange }) => {
  if (!totalPages || totalPages <= 0) return null;

  return (
    <Flex
      justifyContent="center"
      alignItems="center"
      p={4}
      bg="gray.50"
      borderTop="1px solid"
      borderColor="gray.200"
      gap={3}
    >
      <Button
        size="sm"
        onClick={() => handlePageChange(currentPage - 1)}
        isDisabled={currentPage === 1}
        leftIcon={<ChevronLeftIcon />}
        variant="outline"
      >
        {common.PREVIOUS}
      </Button>

      <HStack bg="white" p={1} borderRadius="lg" border="1px solid" borderColor="gray.200">
        <Text fontSize="13px" fontWeight="600" ml={2}>
          {common.PAGE}
        </Text>
        <Select
          size="sm"
          width="60px"
          value={currentPage}
          onChange={(e) => handlePageChange(Number(e.target.value))}
          variant="unstyled"
          fontWeight="700"
          color="blue.600"
        >
          {Array.from({ length: totalPages }, (_, i) => (
            <option key={i + 1} value={i + 1}>
              {i + 1}
            </option>
          ))}
        </Select>
        <Text fontSize="13px" fontWeight="500" mr={2}>
          of {totalPages}
        </Text>
      </HStack>

      <Button
        size="sm"
        onClick={() => handlePageChange(currentPage + 1)}
        isDisabled={currentPage === totalPages}
        rightIcon={<ChevronRightIcon />}
        variant="outline"
      >
        {common.NEXT}
      </Button>
    </Flex>
  );
};
